import { graphql } from 'gatsby'
import React from 'react'
import { BlogPostPage } from '../components/BlogPostPage'
import Layout from '../components/Layout'

const BlogPost = ({ data }: any) => {
  const { markdownRemark: post } = data

  return (
    <Layout title={`${post.frontmatter.title}`} description={post.frontmatter.description}>
      <BlogPostPage
        content={post.html}
        description={post.frontmatter.description}
        title={post.frontmatter.title}
        subtitle={post.frontmatter.subtitle}
      />
    </Layout>
  )
}

export default BlogPost

export const pageQuery = graphql`
  query BlogPostByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        title
        subtitle
        description
      }
    }
  }
`
